import React, { useContext } from 'react'
import { clamp } from '@utils/math'
import Context from '../context.js'
import { stageWidthSelector, stageHeightSelector } from '../selectors/stage_selectors.js'
import { scrollerSelector } from '../selectors/scroller_selectors.js'
import {
  timelineBoundsSelector,
  displayableTimelineItemsSelector,
  getDrilledDownTimelineItem,
  expandedItemBoundsSelector,
} from '../selectors/timeline_display_selectors.js'
import { cancelFreeScroll, updateLeftAndRight } from '../actions.js'
import { drillDownIntoTimelineItem, drillOutOfTimelineItem } from '../actions.js'
import Timeline from '../components/timeline/Timeline'
import type { Timeline as TimelineType, Marker, Timespan, Photo } from '@app-types/entity_types.js'
import type { TimelineItemType } from '../types/types'

type TimelineDisplayContainerProps = {
  timeline: TimelineType
  markers: Marker[]
  timespans: Timespan[]
  photos: Photo[]
}

const TimelineDisplayContainer: React.FC<TimelineDisplayContainerProps> = props => {
  const { timeline, markers, timespans, photos } = props
  const { state, dispatch } = useContext(Context)

  const displayableTimelineItems = displayableTimelineItemsSelector(state, props)
  const timelineDisplayBounds = timelineBoundsSelector(state, props)
  const drilledDownTimelineItem = getDrilledDownTimelineItem(state, props)
  const expandedItemBounds = expandedItemBoundsSelector(state, props)
  const stageWidth = stageWidthSelector(state, props)
  const stageHeight = stageHeightSelector(state, props)
  const scrollerData = scrollerSelector(state, props)

  const newProps = {
    ...props,

    timeline,
    markers,
    timespans,
    photos,
    displayableTimelineItems,
    timelineDisplayBounds,
    drilledDownTimelineItem,
    expandedItemBounds,
    stageWidth,
    stageHeight,
    scrollerData,

    onPanStart: () => {
      dispatch(cancelFreeScroll())
    },
    onPanMove: (left: number, right: number) => {
      dispatch(updateLeftAndRight(clamp(left, 0, 1), clamp(right, 0, 1)))
    },
    onPanEnd: () => {},
    onTimelineItemDrillDown: (id: number, timelineItemType: TimelineItemType) => {
      dispatch(drillDownIntoTimelineItem(id, timelineItemType))
    },
    onTimelineItemDrillUp: (id: number, timelineItemType: TimelineItemType) => {
      dispatch(drillOutOfTimelineItem(id, timelineItemType))
    },
  }
  return <Timeline {...newProps} />
}

export default TimelineDisplayContainer
